import { environment } from '../../environments/environment';

/**
 * Base URL of the FastAPI backend (see gama-backend/main.py).
 * Comes from the active environment file; angular.json swaps the file per
 * configuration (dev/stage/prod).
 */
export const API_BASE = `${environment.apiUrl}/api`;
